export enum WechatScanType {
  未关注,
  已关注,
  已过期
}